export default function PillarsSection({ t }) {
  if (!t.pillars) return null;
  const { suptitle, title, subtitle, items } = t.pillars;
  return (
    <section id="pillars" className="py-20 bg-[#0a0a0a]" data-testid="pillars-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          {suptitle && (
            <span className="inline-block text-xs font-bold tracking-[0.2em] text-[#CDA34F] uppercase mb-4">{suptitle}</span>
          )}
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4 tracking-tight">{title}</h2>
          <p className="text-base text-gray-400 max-w-xl mx-auto">{subtitle}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((pillar) => {
            const Icon = pillar.icon;
            return (
              <div
                key={pillar.name}
                className="group relative bg-[#111] border border-white/10 rounded-2xl p-6 flex flex-col gap-4 hover:border-[#CDA34F]/50 transition-colors duration-300"
              >
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: `${pillar.color}18` }}
                >
                  {Icon && <Icon className="w-5 h-5" style={{ color: pillar.color }} />}
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-base font-extrabold text-white tracking-tight">{pillar.name}</span>
                  </div>
                  <span
                    className="inline-block text-[10px] font-bold tracking-widest uppercase px-2 py-0.5 rounded mb-2"
                    style={{ color: pillar.color, backgroundColor: `${pillar.color}18` }}
                  >
                    {pillar.tag}
                  </span>
                  <p className="text-sm text-gray-400 leading-snug">{pillar.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
